<div class="overly" [ngClass]="{'hidden': !spinnerService.isSpinnerVisible}">
    <div class="spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>

</div>
